<div class="firestone-wrapper">
    <div class="banner-wrapper">
        <div class="container firestone-banner">
            <div class="row">
                <div class="col-xs-12 col-md-8 col-lg-6">
                    <div class="brand">
                        <div class="logo-wrapper">
                            <img class="firestone-img" src="/images/firestone/firestone-white.png" />
                            <div></div>
                            <img src="/images/wrench-logo-white-icon.svg" />
                        </div>
                        <h2><span>Welcome to Wrench,</span> a mobile maintenance and repair partner for Firestone
                            Complete Auto Care</h2>

                        <p>Wrench and Firestone Complete Auto Care are partnering to make car ownership stress-free by
                            offering our convenient mobile repair and maintenance services along with Firestone Complete
                            Auto Care's store locations in select cities.<sup>*</sup> If you book a mobile service with
                            Wrench and we find you need an in-store repair, we have got you covered! Take advantage of
                            our
                            exclusive, <span><b>limited-time offer of 10% off services at participating Firestone
                                    Complete Auto Care stores<sup>*</sup></b></span> and we will get you back on the
                            road as soon as possible.</p>
                    </div>
                </div>
                <div class="hidden-xs col-xs-12 col-md-4 col-lg-6">
                    <div class="header-cta">
                        <a class="order-cta" [routerLink]="['/book/newuser']">Book Service</a>
                    </div>
                </div>
                <div class="col-md-1">
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid clearfix">
        <div class="order-wrap">
            <p>Click the link below <span> to book a mobile service with Wrench! </span></p>
            <a class="order-cta" [routerLink]="['/book/newuser']">Book a mobile service</a>
            <p class="contact">or call <a i18n-href href="tel:+1-877-843-6191" i18n>877-843-6191</a></p>
        </div>
        <div class="services-wrap">
            <div class="row">
                <div class="col-sm-6 col-md-4">
                    <div class="service-card first">
                        <img src="/images/firestone/icon-schedule.svg" />
                        <h3>Auto Repair On YOUR Schedule</h3>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="service-card second">
                        <img src="/images/firestone/icon-certified.svg" />
                        <h3>Full-Time Certified Mechanics</h3>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="service-card third">
                        <img src="/images/firestone/icon-mileage.svg" />
                        <h3>1 year / 12,000 Mile Warranty</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="email-sm-wrap">
            <div class="row">
                <div class="col-sm-6 col-md-5">
                    <div class="email">
                        <h2><span>Not ready</span> to book a mobile repair or maintenance service? </h2>
                        <p>Leave your email in the field below to receive our monthly newsletter for exclusive
                            discounts,
                            news, and information about all things happening at Wrench!</p>
                        <form [formGroup]="newsLetterForm" novalidate>
                            <mat-form-field  class="custom-form">
                                <input matInput formControlName="email" placeholder="Enter email address" />
                            </mat-form-field>
                            <mat-error *ngIf="email.touched && email.invalid">
                                <span *ngIf="email.errors.required">This field is mandatory.</span>
                                <span *ngIf="email.errors.email">Email is invalid.</span>
                            </mat-error>
                            <button class="submit" [disabled]='!newsLetterForm.valid' (click)="createProspect()"
                                value="Submit">Submit</button>
                        </form>
                    </div>
                </div>
                <div class="col-sm-6 col-md-offset-2 col-md-5">
                    <div class="social-media">
                        <h2><span>Be sure to follow</span> Wrench on social </h2>
                        <ul>
                            <li><a target="_blank" href="https://www.facebook.com/getwrench/"><img
                                        src="/images/firestone/facebook.svg" /></a></li>
                            <li><a target="_blank" href="https://www.youtube.com/watch?v=4b0IqJpSugs"><img src="/images/firestone/youtube.svg" /></a></li>
                            <li><a target="_blank" href="https://www.instagram.com/getwrench/"><img
                                        src="/images/firestone/instagram.svg" /></a></li>
                            <li><a target="_blank" href="https://twitter.com/getwrench"><img
                                        src="/images/firestone/twitter.svg" /></a>
                            </li>
                        </ul>
                        <h3> Read Wrench <span> news, tips and tricks.</span></h3>
                        <a class="view-blog" target="_blank" i18n-href href="https://wrench.com/blog/">View Blog</a>
                    </div>
                </div>
            </div>
        </div>
        <footer class="firestone-footer">
            <div class="logo-wrapper">
                <img class="firestone-img" src="/images/firestone/firestone-white.png" />
                <div></div>
                <img src="/images/wrench-logo-white-icon.svg" />
            </div>
            <p class="copyright">© {{currentYear}} Wrench. All rights reserved.</p>
            <div class="notes" [class.notesmobile] = "!showStickyFooter">
                <p><b>*Tires</b> -
                    In store installation required and costs extra. Offer expires 12/31/2022. Valid in Seattle,
                    Sacramento and Phoenix stores only. Not combinable with other offers. Void where prohibited. Other
                    fees, restrictions and taxes may apply. Not available to distributors, dealers, resellers or
                    retailers of Firestone products. Offer excludes commercial, fleet and group purchases, prior
                    purchase, returns, exchanges, outstanding debt, adjustments, warranty replacement purchases, special
                    orders or rain checks.</p>
                <p><b>*Services</b> -
                    Offer expires 12/31/2022. Valid in Seattle, Sacramento and Phoenix stores only. Not combinable with
                    other offers. Void where prohibited. Other fees, restrictions and taxes may apply. Not available to
                    distributors, dealers, resellers or retailers of Firestone products. Offer excludes commercial,
                    fleet and group purchases, prior purchase, returns, exchanges, outstanding debt, adjustments,
                    warranty replacement purchases, special orders or rain checks.</p>
            </div>
        </footer>
    </div>
    <div class="sticky-footer" *ngIf="showStickyFooter">
        <a (click)="showStickyFooter = !showStickyFooter"><i class="fa fa-times"  aria-hidden="true"></i></a>
        <h4>Wrench Mobile Mechanics Come To You</h4>
        <a class="book-service" [routerLink]="['/book/newuser']">Book A Mobile Service</a>
    </div>
</div>
